import { lazy, Suspense } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';

// Lazy load below-the-fold components to improve LCP
const Offers = lazy(() => import('../components/Offers'));
const About = lazy(() => import('../components/About'));
const Guides = lazy(() => import('../components/Guides'));
const FAQ = lazy(() => import('../components/FAQ'));
const News = lazy(() => import('../components/News'));
const Contact = lazy(() => import('../components/Contact'));
const Footer = lazy(() => import('../components/Footer'));

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Suspense fallback={null}>
        <Offers />
        <About />
        <Guides />
        <FAQ />
        <News />
        <Contact />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;


